import { useMemo as i } from "react";
const c = (e, s) => i(() => e && typeof e == "object" ? Object.assign([], Object.entries(e)).map(([t, n]) => {
  const o = s ? s.filter((r) => r.field === t).map((r) => r.message) : [];
  return {
    name: [t],
    errors: o,
    value: n
  };
}) : [], [e, s]);
export {
  c as useFields
};
